/**
 * Client-side, user-tunable settings. Persisted to localStorage so they survive
 * reloads. The pause menu mutates these live; the game loop reads them each
 * frame (aim feel) or on change (master volume).
 */
export interface GameSettings {
  /** How fast the turret/camera catch up to the aim target (point-and-settle
   * — see main.ts's aimTargetAngle). Higher = snappier catch-up, lower =
   * lazier. Slider range ~4..20. */
  aimRate: number;
  /** Master output volume, 0..1. */
  masterVolume: number;
}

const KEY = "tank-settings";

const DEFAULTS: GameSettings = {
  // Playtesting feedback was that the turret felt too twitchy/sensitive to
  // small mouse moves at the original default (9). Still fully adjustable in
  // the pause menu (range 4-20).
  aimRate: 6,
  masterVolume: 0.45,
};

function load(): GameSettings {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return { ...DEFAULTS, ...JSON.parse(raw) };
  } catch {
    /* corrupt / disabled storage → fall back to defaults */
  }
  return { ...DEFAULTS };
}

export const settings: GameSettings = load();

export function saveSettings(): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(settings));
  } catch {
    /* ignore quota / privacy-mode errors */
  }
}
